<template>
    <div class="world-map-mobile">
        <div class="container">
            <h2 class="titre-section"><slot name="titre"></slot></h2>

            <ul class="territory-filters" :class="'select'+activeIndex">
                <li>
                    <a href="" @click.prevent="selectFilter(0)">
                        <slot name="filter1"></slot>

                    </a>
                </li>
                <li>
                    <a href="" @click.prevent="selectFilter(1)">
                        <slot name="filter2"></slot>

                    </a>
                </li>
                <li>
                    <a href="" @click.prevent="selectFilter(2)">
                        <slot name="filter3"></slot>

                    </a>
                </li>
            </ul>

            <transition name="fadeSwipe" mode="out-in">
                <div class="bloc-content" v-if="activeIndex === 0" key="desc1">
                    <slot name="0"></slot>
                </div>
                <div class="bloc-content" v-if="activeIndex === 1" key="desc2">
                    <slot name="1"></slot>
                </div>
                <div class="bloc-content" v-if="activeIndex === 2" key="desc3">
                    <slot name="2"></slot>
                </div>
            </transition>

        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        props: {},
        data() {
            return {
                activeIndex:0
            };
        },
        methods: {
            selectFilter(index){
                this.activeIndex = index
            }
        },
        mounted() {
        },
        destroyed() {
        }
    };
</script>
